(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["images-scroll-grid"] && !Shopify.designMode) return;
  try {
    class ImagesScrollGrid extends HTMLElement {
    connectedCallback() {
      this.columns = Array.from(this.querySelectorAll('[data-column-index]'));
      this.root = this.closest('.images-scroll-grid');
      this.isAutoAnimation = this.root?.classList.contains('images-scroll-grid--animation-auto');
      this.raf = null;
      this.onScroll = this.queueUpdate.bind(this);

      if (this.isAutoAnimation) return;

      this.queueUpdate();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
    }

    disconnectedCallback() {
      if (this.isAutoAnimation) return;

      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.raf) window.cancelAnimationFrame(this.raf);
    }

    queueUpdate() {
      if (this.raf) return;
      this.raf = window.requestAnimationFrame(() => {
        this.raf = null;
        this.updateColumns();
      });
    }

    updateColumns() {
      const rect = this.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const styles = getComputedStyle(this);
      const distance = Number.parseFloat(styles.getPropertyValue('--images-scroll-grid-scroll-distance')) || 140;
      const start = Number.parseFloat(styles.getPropertyValue('--images-scroll-grid-scroll-start')) || 0.35;
      const blockCenter = rect.top + rect.height / 2;
      const startLine = viewportHeight * (1 - start);
      const endLine = viewportHeight * start;
      const travel = startLine - endLine;
      const progress = travel <= 0 ? 0 : Math.min(1, Math.max(0, (startLine - blockCenter) / travel));
      const isMobile = window.matchMedia('(max-width: 750px)').matches;
      const directions = [-1, 1, -1];

      this.columns.forEach((column, index) => {
        const direction = directions[index] || -1;

        if (isMobile) {
          const overflow = Math.max(0, column.scrollWidth - this.clientWidth);
          const centeredOffset = overflow * -0.5;
          const travelDistance = overflow * 0.35;
          const nextOffset = centeredOffset + (progress - 0.5) * travelDistance * direction;
          const clampedOffset = Math.min(0, Math.max(overflow * -1, nextOffset));
          column.style.transform = `translate3d(${clampedOffset}px, 0, 0)`;
        } else {
          const baseOffset = distance * -0.5;
          const offset = progress * distance * 0.5;
          const nextOffset = Math.min(0, Math.max(distance * -1, baseOffset + offset * direction));
          column.style.transform = `translate3d(0, ${nextOffset}px, 0)`;
        }
      });
    }
  }

  if (!customElements.get('images-scroll-grid')) {
    customElements.define('images-scroll-grid', ImagesScrollGrid);
  }
  } catch(e) { console.error(e); }
})();

})();
